import type { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import type { NextRouter } from 'next/router';
import { appendQueryParamsToUrl } from './queryParams';

export class NavigationHandler {
  private readonly router: NextRouter | AppRouterInstance;

  constructor(router: NextRouter | AppRouterInstance) {
    this.router = router;
  }

  navigate(
    path: string,
    additionalParams?: string | string[],
    redirect_url?: string
  ): void {
    const pathToGo = redirect_url || path;
    const newPath = appendQueryParamsToUrl(
      pathToGo,
      additionalParams,
      redirect_url
    );
    this.router.push(newPath.toString());
  }

  goBack(): void {
    this.router.back();
  }
}
